import { useRef, useState } from 'react';
import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';
import './styles.scss';

 interface IGenericPanelProps {
   price: number;
   entity: string;
   onCancel: () => void;
   onSave: (price: number) => void;
 }

const GenericEditPanel = (props: IGenericPanelProps) => {
  const inputRef = useRef(null);
  const [price, setprice] = useState(props.price);

  const onSave = () => {
    const newPrice = Number((inputRef.current as any).innerText);
    setprice(newPrice);
    props.onSave(newPrice);
    props.onCancel();
  };

  const onKeyUp = (event: any) => {
    if (event.charCode === 13) {
      onSave();
    }
  };

  return (
    <>
      <div className='price_edit__backdrop' onClick={(e) => { e.stopPropagation(); props.onCancel(); }} />
      <div className="price_edit__create" onClick={(e) => e.stopPropagation()}>
        <div className="row">
          <div className="row">
            <Text size={14} className='text--grey-200'>{props.entity}</Text>
          </div>
        </div>
        <div className="price_edit__create__new">
          <div className="row priceSelector">
            <div className="input_wrapper">
              <span className='input text--14' >
                <span suppressContentEditableWarning={true} contentEditable ref={inputRef} onKeyPress={onKeyUp} style={{cursor: 'text'}}>
                  {price}
                </span>
              </span>
            </div>
          </div>
          <div className='row'>
            <div className='btnWrapper'>
              <Button text='Cancel' action={props.onCancel} size='s' variant='secondary'></Button>
            </div>
            <div className='btnWrapper'>
              <Button text='Save' action={() => onSave()} size='s' variant='primary'></Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GenericEditPanel;
